import { gql } from "@apollo/client"

export const AgreementDetailsFragment = gql`
  fragment AgreementDetails on Agreement {
    id
    agreementType
    isSynced
    state
    parties
    isAutomated
    reasonForBecomingManual
    lastUpdate {
      file {
        filename
        url
        contentType
      }
      party
      viewedByMe
      timestamp
      userName
    }
    automation {
      state
    }
    lastVerifiedAt
    isESignEnabled
    envelope {
      id
      state
      automationState
      recipients {
        name
        email
        party
        status
        recipientType
      }
      events {
        eventType
        createdAt
      }
    }
    requiredPlaceholders
  }
`
